import { Icon, MessageBar, MessageBarType, Panel, PanelType, Stack } from "office-ui-fabric-react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { getDeskSites } from "../../../api/siteslocations";
import { ISite } from "../../../types/SiteLocation.types";

export interface IBookingSitePanelProps {
    onDismiss: () => void;
    startDateStr: string;
    endDateStr: string;
}

export const BookingSitePanel = (props: IBookingSitePanelProps) => {
    const {startDateStr, endDateStr, onDismiss} = props;
    const history = useHistory();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ loading, setLoading ] = useState(true);
    const [ sites, setSites ] = useState<ISite[]|undefined>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ error, setError ] = useState<string>();

    const _loadSites = async () => {
        setLoading(true);
        const sitesResponse = await getDeskSites();
        if (sitesResponse.ok) {
            setSites((await sitesResponse.json()).filter((s: ISite) => s.DeskBookingEnabled));
        } else {
            setError("Unable to load sites: " + sitesResponse.statusText);
        }
        setLoading(false);
    };

    useEffect(() => {
        _loadSites();
    }, []);

    return (
        <Panel type={PanelType.smallFixedFar} isOpen={true} headerText="Choose a site" onDismiss={onDismiss}>
            <Stack horizontalAlign="center" style={{marginTop:20}}>    
                { sites !== undefined && sites.length > 0 && sites.map((site) => (
                    <button key={`site_${site.Id}`} style={{backgroundColor: "#005EB8", color: "white", borderRadius: 7, marginBottom:10}} onClick={() => {
                        history.push(`/menu/book/desk/${startDateStr}/${endDateStr}/${site.Id}`);
                    }}>
                        <Stack horizontal horizontalAlign="space-around" verticalAlign="center" style={{width: 150, height: 100}}>
                            <Icon iconName="CityNext"/>
                            <div>{site.Title}</div>
                        </Stack>
                    </button>
                ))}
                { sites !== undefined && sites.length === 0 && (
                    <MessageBar messageBarType={MessageBarType.info}>No desk booking available</MessageBar>
                )}
            </Stack>
        </Panel>
    );
}